import React, { useState, useEffect, useRef } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./sections/Hero";
import About from "./sections/About";
import ProblemStatements from "./sections/ProblemStatements";
import Timeline from "./sections/Timeline";
import Prizes from "./sections/Prizes";
import Sponsors from "./sections/Sponsors";
import Judges from "./sections/Judges";
import LiveUpdates from "./sections/LiveUpdates";
import FAQs from "./sections/FAQs";
import Contact from "./sections/Contact";
import Footer from "./components/Footer";
import OurTeam from "./Pages/Ourteam";
import Error404 from "./Pages/Error404";
import RegisterPage from "./Pages/RegisterPage";
import Support from "./Pages/Support_team";
import Guidelines from "./Pages/Guidelines";
import Announcement from "./sections/Announcement";
import CertificatePage from "./Pages/CertificatePage";

const App = () => {
  const heroRef = useRef(null);
  const aboutRef = useRef(null);
  const contactRef = useRef(null);
  const faqsRef = useRef(null);
  const judgesRef = useRef(null);
  const liveRef = useRef(null);
  const prizeRef = useRef(null);
  const problemRef = useRef(null);
  const sponsorsRef = useRef(null);
  const timelineRef = useRef(null);
  const trackRef = useRef(null);

  const [loading, setLoading] = useState(true);


  return (
    <Router>
        <div className="app">

            <Navbar 
              heroRef={heroRef}
              aboutRef={aboutRef}
              contactRef={contactRef}
              faqsRef={faqsRef}
              judgesRef={judgesRef}
              problemRef={problemRef}
              sponsorsRef={sponsorsRef}
              timelineRef={timelineRef}
            />

          <Routes>
            <Route
              path="/"
              element={
                <>
                  <Hero />
                  <About ref={aboutRef} />
                  <ProblemStatements ref={problemRef} />
                  <Sponsors ref={sponsorsRef} />
                  <Judges ref={judgesRef} />
                  <Announcement />
                  <Prizes ref={prizeRef} />
                  <FAQs />
                  <Footer ref={contactRef} />
                </>
              }
            />

            <Route 
              path="/ourteam" 
              element={
                <>
                  <OurTeam />
                  <Footer />
                </>
              } 
            />

            <Route 
              path="/register"
              element={
                <>
                <RegisterPage />
                <Footer />
                </>
              }
            />

            <Route 
              path="/support"
              element={
                <>
                <Support />
                <Footer />
                </>
              }
            />
            
            <Route 
              path="/certificates"
              element={
                <>
                <CertificatePage />
                <Footer />
                </>
              }
            />

            <Route 
              path="/problem-statements"
              element={
                <>
                
                <ProblemStatements ref={problemRef} />
                <Footer />
                </>
              }
            />

            <Route 
              path="/guide"
              element={
                <>
                <Guidelines />
                <Footer />
                </>
              }
            />

          <Route 
            path="*" 
            element={
            <Error404 />
            } 
          />

          </Routes>
          
        </div>
    </Router>
  );
};

export default App;
